import axios from 'axios';

/*
const apiUrl = {
    prod: 'https://rest.xplorariviera.com',
    local: 'http://localhost:4000',
    azure_dev: 'https://rest.xplorariviera.com:8080'
}
*/

export const url = axios.create({
  baseURL: process.env.XPLORA_API,
});

if (process.env.NODE_ENV === 'development') {
  // Request interceptor
  url.interceptors.request.use(
    config => {
      console.log(`[${config.method?.toUpperCase()}] ${config.url}`);
      if (config.params && Object.keys(config.params).length > 0) {
        console.log('params:', config.params);
      }
      if (config.data && Object.keys(config.data).length > 0) {
        console.log('body:', config.data);
      }
      return config;
    },
    error => {
      console.error('Request Error:', error);
      return Promise.reject(error);
    },
  );

  // Response interceptor
  url.interceptors.response.use(
    response => response,
    error => {
      if (error.response) {
        console.error(`❌[${error.config.method?.toUpperCase()}] ${error.config.url}`);
        if (error.response.data) console.error('Response data:', error.response.data);
      } else if (error.request) {
        console.error('No response received:', error.request);
      } else {
        console.error('Error:', error.message);
      }
      return Promise.reject(error);
    },
  );
}
